import React from 'react'
import { Typography } from '@material-ui/core'
import { states } from '../../../services/helpers'

const AddressBlock = ({ household }) => {
	if (!household || !household.contact || !household.contact.address) {
		return null
	}

	const { contact } = household
	let { address } = contact
	let { address_line_1, address_line_2, city, state, zip_code } = address

	state = states.find((s) => s.id.toString() === state)

	return (
		<div>
			{contact ? (
				<div>
					<Typography variant="body2">{address_line_1 || 'No address'}</Typography>
					{address_line_2 ? <Typography variant="body2">{address_line_2}</Typography> : null}
					<Typography variant="body2">{`${city ? city : ''}${state ? `, ${state.name}` : ''}${
						zip_code ? ` ${zip_code}` : ''
					}`}</Typography>
				</div>
			) : null}
		</div>
	)
}

export default AddressBlock
